import Settings from 'views/Dashboard/Settings';
import Icons from 'views/Dashboard/Icons';

import SignIn from 'views/Auth/SignIn.js';
import Forgot from 'views/Auth/Forgot.js';

import {
  HomeIcon,
  DocumentIcon,
  KioskIcon,
  KioskActiveIcon,
} from 'components/Icons/Icons';
import Partners from './views/Dashboard/Partners';
import ApiKeys from './views/Dashboard/ApiKeys';
import RequestLogs from './views/Dashboard/RequestLogs';
import PosTransactions from './views/Dashboard/PosTransactions';
import UserPurchases from './views/Dashboard/UserPurchases';
import MarketPrices from './views/Dashboard/MarketPrices';
import BasePrices from './views/Dashboard/BasePrices';
import Stations from './views/Dashboard/Stations';

export const sidebar = [
  {
    path: 'partners',
    name: 'Partners',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: Partners,
    layout: '/',
    endpoints: ['GET:/admin/partners', 'POST:/admin/partners'],
  },
  {
    path: 'api-keys',
    name: 'API Keys',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: ApiKeys,
    layout: '/',
    endpoints: ['GET:/admin/api-keys', 'POST:/admin/api-keys'],
  },
  {
    path: 'request-logs',
    name: 'Request Logs',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: RequestLogs,
    layout: '/',
    endpoints: ['GET:/admin/request-logs'],
  },
  {
    path: 'pos-transactions',
    name: 'POS Transactions',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: PosTransactions,
    layout: '/',
    endpoints: ['GET:/admin/pos-transactions'],
  },

  {
    path: 'user-purchases',
    name: 'User Purchases',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: UserPurchases,
    layout: '/',
    endpoints: ['GET:/admin/user-purchases', 'GET:/admin/user-purchases/stats'],
  },
  {
    path: 'market-prices',
    name: 'Market Prices',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: MarketPrices,
    layout: '/',
    endpoints: ['GET:/admin/market-prices', 'POST:/admin/market-prices'],
  },
  {
    path: 'base-prices',
    name: 'Base Prices',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: BasePrices,
    layout: '/',
    tabEndpoints: [
      {
        name: '/',
        endpoints: ['GET:/admin/base-prices', 'POST:/admin/base-prices'],
      },
      {
        name: '/next-base-prices',
        endpoints: [
          'GET:/admin/next-base-prices',
          'POST:/admin/next-base-prices',
        ],
      },
    ],
  },
  {
    path: 'stations',
    name: 'Stations',
    rtlName: 'لوحة القيادة',
    icon: <KioskIcon color="#8794C2" />,
    iconActive: <KioskActiveIcon color="#099BFF" />,
    component: Stations,
    layout: '/',
    endpoints: ['GET:/admin/stations', 'POST:/admin/stations'],
  },
];

export const other = [
  {
    path: 'settings',
    name: 'Settings',
    rtlName: 'لوحة القيادة',
    icon: <HomeIcon color="inherit" />,
    component: Settings,
    layout: '/',
  },
  {
    path: 'icons',
    name: 'Icons',
    rtlName: 'الرموز',
    // icon: <HomeIcon color="inherit" />,
    component: Icons,
    layout: '/',
  },
];

export const auth = [
  {
    name: 'AUTH',
    category: 'account',
    rtlName: 'صفحات',
    state: 'pageCollapse',
    views: [
      {
        path: '/signin',
        name: 'Sign In',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: '/auth',
      },
      {
        path: '/forgot-password',
        name: 'Forgot Password',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: Forgot,
        layout: '/auth',
      },
    ],
  },
];

const routes = [...sidebar, ...other, ...auth];
export default routes;
